<script setup lang="ts">
import { defineProps, ref, watch } from 'vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  data: {
    tracking_service: string;
    tdsensor: boolean;
  };
  errors: { tdsensor: string };
  windowInnerWidth: number;
}>();
const emit = defineEmits(['inputValue']);
const tdsensor = ref(false);
const beforeTdsensor = ref(false);

const unwatch = watch(
  () => props.data,
  (propsData) => {
    tdsensor.value = propsData.tdsensor;
    beforeTdsensor.value = propsData.tdsensor;
    unwatch();
  }
);

watch(
  () => props.data.tracking_service,
  () => {
    if (!beforeTdsensor.value) beforeTdsensor.value = props.data?.tdsensor;
    let value = beforeTdsensor.value;
    if (props.data?.tracking_service != 'octlink') value = false;

    emit('inputValue', { tdsensor: value });
  }
);

watch(tdsensor, () => {
  beforeTdsensor.value = tdsensor.value;
  emit('inputValue', { tdsensor: tdsensor.value });
});
</script>
<template>
  <v-row
    class="text-form pl-4 pr-3 mb-3 align-center"
    v-if="props.data?.tracking_service == 'octlink'"
  >
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-4 pt-2">
        {{ i18n.global.t('pages.operationOffices.form.validTdsensor') }}
      </h6>
    </v-col>
    <v-col :cols="windowInnerWidth > 800 ? 10 : 9">
      <v-col cols="1">
        <v-switch v-model="tdsensor" color="blue" />
      </v-col>
    </v-col>
  </v-row>
</template>
